const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../framework/core/module_manager";
import DialogTips from "../../public/module/dialog_tips/dialog_tips";
import ClubPromotionView from "./club_promotion_view";
import ModelData, { IUserData } from "../../public/model_data";
import ClubRecord from "../clubRecord/club_record";
import ClubShare from "../clubShare/club_share";
import BindInviteCode from "../../hall/module/bindinvitecode/bindinvitecode";

@ccclass
@moduleInit("ClubPromotion")
export default class ClubPromotion extends ModuleBase<ClubPromotionView, null>  {
    clubId = null
    code = null
    curData = null //当前推广数据
    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/club/module/club_promotion';       
        this.viewType = ClubPromotionView;
        this.needDeferShow = true
        this.needAnim = true
        this.autoShowAnim = true
        this.needViewMask = true
    }

    protected onDeferShow(intentData) {
        if (intentData != null){
            this.clubId = intentData.clubId
            this.code = intentData.code
            this.getPromotionData(this.clubId)
        }
        
    }

    onInit(){
        this.bindEvent();
    }


    protected onButtonClickName(name : string) {
        switch (name) {
            case "BackBtn":
                ModuleManager.instance.hideModule("ClubPromotion")
                break;
            case "XYJLBtn":
                ModuleManager.instance.showModule<ClubRecord>(ClubRecord, this.clubId)
                break;
            case "ZMLJBtn":
                ModuleManager.instance.showModule<ClubShare>(ClubShare, {clubId : this.clubId, clubCode : this.code})
                break;
            case "JRTGBtn":
                ModuleManager.instance.showModule<BindInviteCode>(BindInviteCode)
                break;
            case "CRYHBtn":
                this.view.bankTipsNode.active = true
                break;
            case "BankTipsBackBtn":
                this.view.bankTipsNode.active = false
                break;
            case "BankTipsMask":
                this.view.bankTipsNode.active = false
                break;
            case "BankTipsLeftBtn":
                this.view.bankTipsNode.active = false
                break;
            case "BankTipsRightBtn":
                this.setRankData(this.clubId)
                break;
            default:
                break;
        }
    }


    getPromotionData(clubId){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "club/permance/getThiskWeek?",
            params: {
                clubId:clubId,
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.show()
            self.curData = respone.data
            self.view.showBaseInfo(respone.data, ModelData.instance.roleData)//更新数据
        })
    }

    setRankData(clubId){
        let self = this
        if (Number(self.curData.advance) <= 0){
            this.view.bankTipsNode.active = false
            return
        }
        let requestData: IHttpRequestData = {
            baseUrl: "club/permance/receiveAdvance?",
            params: {
                clubId:clubId,
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.getPromotionData(clubId)
            this.view.bankTipsNode.active = false
        })
    }

    updateShow(){
        let self = this
        this.getUserData(ModelData.instance.roleData.id, (data: IUserData) => {
            self.view.showBaseInfo(self.curData, data)//更新数据
        })
    }

    bindEvent(){
        this.eventBind("event_bind_code",this.updateShow)
        
    }
}